webpackJsonp([169161887741629],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chineseMedicine = function chineseMedicine() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Chinese Medicine'
	    ),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'Chinese Medicine is a complete medical system and has been used successfully for over 2,000 years to treat a wide variety of conditions. Chinese medicine understands the body to be much like the natural world. In the natural world, one ecosystem is interdependent on another. Just as rivers create fertile valleys and strong forests hold landslides at bay, our body is made of interconnected systems supporting the whole. And just like the natural world\u2019s astounding ability to regenerate after damage or disaster, so too can the body gain rebalance from illness. Chinese medicine is not about forcing unnatural conditions. It is about reminding the body of its own natural healing capacity, and providing the tools that it needs to best enact this.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'What began over 2,000 years ago in China is now a vast, multi-disciplinary system of medicine that includes techniques honed and developed in dozens of countries, including, China, Japan, Korea, France, and the United States. At the heart of this medicine is a central belief in the body\u2019s ability to heal itself. Using five main branches, Acupuncture, Herbal Medicine, Nutrition, Tui Na and Qi Gong, Chinese medicine is a complete medical system that is safe, gentle, effective and time-tested.'
	      ),
	      _react2.default.createElement(
	        'h4',
	        null,
	        'The five primary branches of Chinese Medicine are:'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            paddingLeft: '30px'
	          }
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Acupuncture:'
	          ),
	          ' According to Chinese medicine, qi (\u201Cchee\u201D) or energy, flows through the body on specific pathways. When the energy in these pathways is blocked, blood and fluids may become blocked as well. There can be pain, discomfort, tissue and organ dysfunction. Acupuncture is the insertion of super-fine, sterile needles into specific points along these energy channels. Needles allow the body to unblock congestion and allow for smooth flow and rebalancing of qi and fluids through the body. An acupuncturist may use tools other than or in addition to needles to help balance the body\u2019s qi and fluids, including acupressure, cupping (the creation of suction using glass or plastic cups to release adhesions and re-nourish tissues), moxibustion (the burning of moxa, or Chinese mugwort, near acupuncture points to increase circulation) and gua sha (the application of friction and pressure designed to increase blood flow and move stagnation in congested tissues).'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Herbal Medicine:'
	          ),
	          ' Chinese medicine uses over 350 plants, minerals and other organic materials to address the underlying causes of disease. Herbs with different properties are combined into formulas specifically tailored to the unique condition and constitution of each patient. Herbs can be taken as teas made from raw, powdered or granular herbs, or as teapills. Herbal medicine plays a significant role in the treatment of certain conditions.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Nutrition:'
	          ),
	          ' Food is medicine, and different foods affect the body in different ways . In some cases, it may be necessary to modify one\u2019s diet to achieve a long-term health goal, including the removal or addition of certain foods within the diet. Some conditions can be addressed by food alone, without the use of additional medicine.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Tui Na:'
	          ),
	          ' Tui Na is a form of therapeutic massage based on the chinese concept of energy pathways or \u201Cmeridians.\u201D Using knowledge of energy meridians, tui na helps restore proper flow of energy and fluid to the muscles, tendons, ligaments, and joints.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Qi Gong:'
	          ),
	          ' As in any system of medicine, exercise is an important aspect of generating and maintaining health. Qi Gong, which literally means to \u201Ccultivate energy,\u201D is an ancient set of movements, breathing techniques and focused intention designed to promote natural energy, or qi, flow, develop strength, focus and flexibility. Chinese Medical practitioners may prescribe qi gong exercises as part of a treatment strategy to address specific health complaints.'
	        )
	      ),
	      _react2.default.createElement(
	        'i',
	        null,
	        'The National Institute of Health (NIH) and World Health Organization (WHO) recognize acupuncture as effective for treating the following conditions:'
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Ear, Eye, Nose, Throat Disorders:'
	        ),
	        ' Sinusitis \u2022 Sore throat\u2022 Hay fever \u2022 Earache \u2022 Nerve deafness\u2022 Ringing in the ears \u2022 Dizziness \u2022 Poor eyesight'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Circulatory Disorders:'
	        ),
	        ' High blood pressure \u2022 Angina pectoris \u2022 Arteriosclerosis \u2022 Anemia'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Gastrointestinal Disorders:'
	        ),
	        ' Irritable bowel syndrome \u2022 Spastic colon \u2022 Colitis \u2022 Constipation \u2022 Diarrhea \u2022 Food Allergies \u2022 Ulcers \u2022 Gastritis \u2022 Abdominal bloating \u2022 Hemorrhoids'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Gynecological and Genitourinary Disorders:'
	        ),
	        ' Premenstrual syndrome (PMS) \u2022 Irregular, heavy, or painful menstruation \u2022 Endometriosis \u2022 Menopause \u2022 Fibroids \u2022 Chronic bladder infection \u2022 Complications in pregnancy \u2022 Morning sickness \u2022 Kidney stones \u2022 Impotence \u2022 Infertility in men and women \u2022 Sexual dysfunction'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Immune Disorders:'
	        ),
	        ' Candida \u2022 Chronic fatigue \u2022 HIV and AIDS \u2022 Epstein Barr virus \u2022 Allergies \u2022 Lupus \u2022 MS \u2022 Hepatitis'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Addiction:'
	        ),
	        ' Smoking Cessation \u2022 Drugs \u2022 Alcohol'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Emotional and Psychological Disorders:'
	        ),
	        ' Anxiety \u2022 Insomnia \u2022 Depression \u2022 Stress'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Musculoskeletal and Neurological Disorders:'
	        ),
	        ' Arthritis \u2022 Neuralgia \u2022 Sciatica \u2022 Back pain \u2022 Bursitis \u2022 Tendonitis \u2022 Stiff neck \u2022 Bell\u2019s palsy \u2022 Trigeminal Neuralgia \u2022 Headaches and Migraines \u2022 Stroke \u2022 Cerebral palsy \u2022 Polio \u2022 Sprains \u2022 Muscle spasms \u2022 Shingles'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Respiratory Disorders:'
	        ),
	        ' Asthma \u2022 Emphysema \u2022 Bronchitis \u2022 Colds and flu'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Miscellaneous:'
	        ),
	        ' Chemotherapy and radiation side effects \u2022 Diabetes \u2022 Dermatological disorders \u2022 Weight control'
	      )
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = chineseMedicine;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-chinese-medicine-js-35f1b9f451885a839be9.js